'use client';

import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';

export default function Providers({ children, session, baseUrl }: { children: React.ReactNode; session: Session | null, baseUrl: string }) {
  return (
    <SessionProvider session={session} baseUrl={baseUrl}  basePath="/api/auth">
      {children}
    </SessionProvider>
  );
}
